import { render } from "./ProfitCalculatorPage.vue?vue&type=template&id=03561a4e&scoped=true"
import script from "./ProfitCalculatorPage.vue?vue&type=script&lang=js"
export * from "./ProfitCalculatorPage.vue?vue&type=script&lang=js"

import "./ProfitCalculatorPage.vue?vue&type=style&index=0&id=03561a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03561a4e"]])

export default __exports__